type ClassOf<T> = { prototype: T };

export function setToStringTag<T extends object>(
  classCtor: ClassOf<T>,
  tag: string
): void {
  if (typeof Symbol === "undefined" || !Symbol.toStringTag) return;

  Object.defineProperty(classCtor.prototype, Symbol.toStringTag, {
    value: tag,
    writable: false,
    enumerable: false,
    configurable: true,
  });
}
